'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ThreadPreviewRecord = (0, _immutable.Record)({
  hasFileAttachment: false
});

exports.default = ThreadPreviewRecord;
module.exports = exports['default'];